import { Component, computed, Input } from '@angular/core';
import { SlotData } from 'src/app/gamification/services/models/ranking.model';

@Component({
  selector: 'app-slot',
  templateUrl: './slot.component.html',
  styleUrls: ['./slot.component.scss']
})
export class SlotComponent {
  @Input() slot!: SlotData;
  @Input() userId!: string;

  readonly isUserSlot = computed(() => this.slot.user === this.userId);
}
